/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_CustomInputs */

const en_admin_settings_tabs_custom = /** @type {(inputs: Admin_Settings_Tabs_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const zh_admin_settings_tabs_custom = /** @type {(inputs: Admin_Settings_Tabs_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Admin_Settings_Tabs_CustomInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_custom = /** @type {((inputs?: Admin_Settings_Tabs_CustomInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_CustomInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_custom(inputs)
	return zh_admin_settings_tabs_custom(inputs)
});
export { admin_settings_tabs_custom as "admin.settings.tabs.custom" }